<template>
  <div
    :class="customClass"
    class="w-100 d-flex flex-wrap flex-row  align-items-start"
  >
    <h6
      class="mb-1 week-day"
      v-for="weekDay in weekDays"
      :key="weekDay.key"
      @click="checkUncheckWeekDay(weekDay.key)"
    >
      <div
        class="p-2 rounded-circle"
        style="text-align: center;"
        :style="
          (!value.includes(weekDay.key)
            ? 'border:1px solid #bdbcbc;'
            : 'border:1px solid transparent;') +
            (size == 'sm'
              ? 'min-width: 30px; line-height: 12px; font-size:14px;'
              : 'min-width: 37px')
        "
        :class="
          value.includes(weekDay.key)
            ? 'text-white bg-success'
            : 'text-black bg-light'
        "
        v-b-tooltip.hover
        :title="weekDay.tooltip"
      >
        {{ weekDay.label }}
      </div>
    </h6>
  </div>
</template>

<script>
const weekDays = {
  sunday: {
    key: "0",
    tooltip: "Sunday",
    label: "S"
  },
  monday: {
    key: "1",
    tooltip: "Monday",
    label: "M"
  },
  tuesday: {
    key: "2",
    tooltip: "Tuesday",
    label: "T"
  },
  wednesday: {
    key: "3",
    tooltip: "Wednesday",
    label: "W"
  },
  thursday: {
    key: "4",
    tooltip: "Thursday",
    label: "T"
  },
  friday: {
    key: "5",
    tooltip: "Friday",
    label: "F"
  },
  saturday: {
    key: "6",
    tooltip: "Saturday",
    label: "S"
  }
};

export default {
  name: "WeekDaysPicker",
  props: ["value", "align", "disabled", "size"],
  methods: {
    checkUncheckWeekDay(weekDayKey) {
      if (this.disabled) return;
      let newValue = [...this.value];
      if (this.value.includes(weekDayKey))
        newValue.splice(this.value.indexOf(weekDayKey), 1);
      else newValue.push(weekDayKey);

      this.$emit("input", newValue);
    }
  },
  computed: {
    weekDays() {
      return Object.values(weekDays);
    },
    customClass() {
      const classes = [];
      if (this.align == "left") {
        classes.push("justify-content-start");
      }
      if (!this.align) {
        classes.push("justify-content-center");
      }
      return classes.join(" ");
    }
  }
};
</script>

<style scoped>
.week-day:hover {
  cursor: pointer;
}
.week-day {
  margin-right: 8px;
}
</style>
